import { SupportedLocale, withLocalePath } from "./locales";

const LOCALIZED_STATIC_PATHS = new Set<string>([
  "/",
  "/about",
  "/features",
  "/pricing",
  "/privacy",
  "/terms",
  "/support",
  "/login",
  "/signup",
  "/transcribe-video-with-chatgpt",
  "/video-to-text",
  "/payment/canceled",
  "/payment/success",
]);

const LOCALIZED_PREFIXES = ["/tools", "/payment"];

export function isLocalizableSeoPath(path: string): boolean {
  if (!path.startsWith("/")) {
    return false;
  }

  if (path.startsWith("/files") || path.startsWith("/api") || path.startsWith("/_next")) {
    return false;
  }

  if (LOCALIZED_PREFIXES.some(prefix => path === prefix || path.startsWith(`${prefix}/`))) {
    return true;
  }

  return LOCALIZED_STATIC_PATHS.has(path);
}

export function withSeoLocalePath(locale: SupportedLocale, path: string): string {
  return isLocalizableSeoPath(path) ? withLocalePath(locale, path) : path;
}
